"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var AddPicture = function AddPicture(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: '0 0 218.166 218.166'
  }, props), /*#__PURE__*/_react["default"].createElement('g', null, /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M91.233,148.75h-83.3V17.85h166.6V83.3c0,2.192,1.774,3.967,3.967,3.967s3.967-1.774,3.967-3.967V13.883\r c0-2.192-1.774-3.967-3.967-3.967H3.967C1.774,9.917,0,11.691,0,13.883v138.833c0,2.192,1.774,3.967,3.967,3.967h87.267\r c2.192,0,3.967-1.774,3.967-3.967C95.2,150.524,93.426,148.75,91.233,148.75z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M91.233,132.883H23.8v-24.141l20.232-20.232l27.003,19.806c1.522,1.119,3.626,1.007,5.02-0.271l42.316-38.633\r l17.234,24.125c1.271,1.782,3.75,2.196,5.532,0.922c1.782-1.271,2.196-3.75,0.922-5.532L122.226,61.16\r c-0.658-0.926-1.681-1.522-2.808-1.639c-1.115-0.12-2.255,0.248-3.091,1.015l-43.219,39.46L45.981,80.1\r c-1.58-1.158-3.769-0.992-5.152,0.395L23.8,97.524V33.717h134.867V83.3c0,2.192,1.774,3.967,3.967,3.967\r c2.192,0,3.967-1.774,3.967-3.967V29.75c0-2.192-1.774-3.967-3.967-3.967h-142.8c-2.192,0-3.967,1.774-3.967,3.967v107.1\r c0,2.192,1.774,3.967,3.967,3.967h71.4c2.192,0,3.967-1.774,3.967-3.967C95.2,134.659,93.426,132.883,91.233,132.883z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M162.633,97.183c-30.621,0-55.533,24.912-55.533,55.533c0,30.621,24.912,55.533,55.533,55.533\r c30.621,0,55.533-24.912,55.533-55.533C218.166,122.095,193.255,97.183,162.633,97.183z M162.633,200.318\r c-26.248,0-47.6-21.352-47.6-47.6s21.352-47.6,47.6-47.6s47.6,21.352,47.6,47.6C210.233,178.966,188.882,200.318,162.633,200.318\r z'
  }), /*#__PURE__*/_react["default"].createElement('polygon', {
    points: '166.6,120.983 158.667,120.983 158.667,148.75 130.9,148.75 130.9,156.683 158.667,156.683 158.667,184.451\r 166.6,184.451 166.6,156.683 194.367,156.683 194.367,148.75 166.6,148.75 \t\t\t'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M43.633,57.517c0,8.751,7.116,15.867,15.867,15.867s15.867-7.116,15.867-15.867c0-8.751-7.116-15.867-15.867-15.867\r S43.633,48.766,43.633,57.517z M67.433,57.517c0,4.373-3.56,7.933-7.933,7.933s-7.933-3.56-7.933-7.933\r c0-4.373,3.56-7.933,7.933-7.933S67.433,53.144,67.433,57.517z'
  })));
};
/* eslint-enable */
var _default = AddPicture;
exports["default"] = _default;